<template>
  <div>
    <div class="channel" v-if="isLimit">
      <div class="search flex-center">
        <van-search
            class="flex1"
            v-model="name"
            clear-trigger="always"
            @clear="clearSearch"
            placeholder="搜索活码名称"
        />
        <span span="4" @click="search" class="search-text">搜索</span>
      </div>
      <van-list
          v-model="loading"
          :finished="finished"
          loading-text="正在加载中..."
          finished-text="暂无更多内容了"
          @load="load_more"
      >
        <van-row>
          <van-col span="24" v-for="item in channelList" :key="item.id">
            <div @click="linkDetail(item)" class="item flex-center">
              <van-image fit="cover" :src="item.qrCode" rel="external nofollow" />
              <div class="title flex1">
                <h4 class="van-ellipsis">{{ item.name }}</h4>
                <p>添加人数：{{ item.sum || 0 }}</p>
                <p class="van-ellipsis">扫码员工：{{ item.userNams }}</p>
                <p>{{ item.createTime }}</p>
              </div>
            </div>
          </van-col>
        </van-row>
      </van-list>
    </div>
    <emptyPage :isLimit="isLimit"/>
  </div>
  
</template>

<script>
import { Toast } from "vant";
import { weqrcodeList } from "@/server/api.js";
import {wefunstatistics,pageLimit} from "@/utils/public";
import emptyPage from "@/components/emptyPage";
export default {
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 20,
      name: "",
      loading: false,
      finished: false,
      total: 0, // 总条数
      channelList: [],//列表集合
      isLimit:"",
    };
  },
  components:{ emptyPage },
  async mounted() {
    let that = this;
    await pageLimit('qrcode:query',function (bool){
      that.isLimit = bool;
    });
    if(this.isLimit){
      Toast.loading();
      await this.getChannelList();
      await wefunstatistics("11", window.location.href.split('#')[0]);
    }
  },
  methods: {
    async getChannelList() {
      this.loading = true;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.name,
      };
      const res = await weqrcodeList(params);
      if (res.code !== "200") return Toast.fail(res.msg);
      // 加载状态结束
      this.loading = false;
      this.channelList = this.channelList.concat(res.data.list); //追加数据
      this.total = res.data.totalCount;
      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
    //加载更多
    load_more() {
      this.pageNum++;
      this.getChannelList();
    },
    search() {
      this.channelList = [];
      this.getChannelList();
    },
    clearSearch() {
      console.log(this.name);
      this.name = "";
      this.getChannelList();
    },
    linkDetail(obj) {
      this.$router.push({
        path: "/detail",
        query: {
          id: obj.id,
          title: obj.name,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.channel {
  width: 100%;
  height: 100%;
  background: #f5f6fa;

  .van-search {
    padding: 0;
    /deep/.van-icon-search {
      font-size: 28px;
    }
    /deep/.van-field__control {
      font-size: 28px;
    }
  }
  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }
  .van-search .van-cell {
    align-items: center;
  }
  .van-field__left-icon {
    height: 80px;
  }
  .search-text {
    font-size: 32px;
    padding-left: 20px;
    cursor: pointer;
  }
  .search {
    padding: 20px 30px;
    background: #fff;
  }
  .item {
    margin: 20px 30px;
    padding: 20px 18px;
    background: #fff;
    border-radius: 14px;
    .van-image {
      width: 180px;
      height: 180px;
    }
    .title {
      min-width: 0;
      font-size: 28px;
      padding-left: 19px;
      height: 180px;
      box-sizing: border-box;
      h4 {
        height: 55px;
      }
      p {
        font-size: 26px;
        color: #666666;
        height: 45px;
        &:last-of-type {
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
